import React from "react";

import { BarChart, BarChartNew } from "../../../../../../shared";
import { BenifitSummaryEnrollmentCard } from "../../../../../../../@types/components/enrollmentCardGrid.types";
import { LegendIndicator } from "../../../../../../../@types/charts/barCharts.types";

import "./enrollmentCard.css";

const EnrollmentCard: React.FC<BenifitSummaryEnrollmentCard> = ({
	cardUIProps,
	chartProps,
	chartLegend
}): JSX.Element => {
	const { cardTitle, cardColor, overallTotal, marginTopText } = cardUIProps;
	const { data, options } = chartProps;
	//
	return (
		<div className="enrollment-card" style={{ backgroundColor: `${cardColor}` }}>
			<div className="element-section-title">{cardTitle}</div>
			<div className="element-section-value" style={marginTopText ? { marginTop: `${marginTopText}` } : {}}>
				{overallTotal}
			</div>
			<div className="element-section-chart">
				{chartProps ? <BarChartNew data={data as any} options={options} /> : <></>}
			</div>
			<div className="element-section-legend">
				{chartLegend ? (
					chartLegend.map((element: LegendIndicator, index: number) => {
						return (
							<div className="plan-container" key={index}>
								<div
									className="plan-color-indicator"
									style={{
										color: element.colorIndicator,
										backgroundColor: element.colorIndicator,
										height: "0.7rem",
										width: "0.7rem"
									}}
								>
									o
								</div>
								<div className="plan-color-name">{element.labelName}</div>
							</div>
						);
					})
				) : (
					<></>
				)}
			</div>
		</div>
	);
};

export default EnrollmentCard;
